import { Button } from "components/DesignSystem/Button/Button";
import { PendingDuesIcon } from "components/icons/PendingDuesIcon";
import { RightArrow } from "components/icons/RightArrow";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useModal } from "hooks/useModal";
import ReactCountryFlag from "react-country-flag";
import { TaxActionItemType } from "store/apis/actionItems";
import { InvoicesList } from "./InvoicesList";

export const PendingInvoicesRow = ({
  item,
  groupIdFromProps,
}: {
  item: TaxActionItemType;
  groupIdFromProps?: string;
}) => {
  const actionModal = useModal();
  const { entities } = useCurrentGroupContext();
  const entity = entities.find((entity) => entity.uuid === item.entity_id);

  return (
    <>
      <div
        className="t-flex t-justify-between t-items-center t-py-4 t-px-2 t-border t-border-solid t-border-neutral-0 t-border-t-surface-transparent t-border-l-surface-transparent t-border-r-surface-transparent t-group active:t-border-purple active:t-border-t-purple active:t-border-r-purple active:t-border-l-purple t-rounded-lg hover:t-bg-surface-lighter-grey"
        onClick={actionModal.open}
        role="button"
      >
        <div className="t-flex t-gap-2 t-items-center">
          <div className="t-relative t-min-h-10 t-min-w-10 t-max-h-10 t-max-w-10 t-rounded-full t-flex t-items-center t-justify-center t-bg-surface-lighter-grey">
            <PendingDuesIcon />
          </div>

          <div className="t-space-y-1">
            <div className="t-text-subtext t-text-text-100">
              {item.count} {item.title}
            </div>
            {entity && (
              <div className="t-flex t-gap-1.5 t-items-center">
                <div className="t-rounded-sm">
                  <ReactCountryFlag
                    svg
                    countryCode={entity.country_code}
                    height={12}
                    width={12}
                  />
                </div>
                <div className="t-text-body-sm t-text-text-30 t-mt-0.5">
                  {entity.name}
                </div>
              </div>
            )}
          </div>
        </div>
        <Button size="small" customType="text">
          <div className="t-text-text-60 group-hover:t-hidden t-block">
            <RightArrow />
          </div>
          <div className="t-hidden group-hover:t-block">View</div>
        </Button>
      </div>

      <InvoicesList
        {...actionModal}
        entityId={item.entity_id}
        groupIdFromProps={groupIdFromProps}
      />
    </>
  );
};
